import { useState } from 'react'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import ItemTabs from 'components/ItemTabs'
import Services from './Services'
import Products from './Products'
import ServiceCategories from './ServiceCategories'
import ProductCategories from './ProductCategories'
import PromoCodes from './PromoCodes'
import { Container } from './styles'

export default function Config () {
  const [option, setOption] = useState (localStorage.getItem ('config_option') ?? 'promo_codes')
  //const [category, setCategory] = useState (localStorage.getItem ('service_category'))

  const OPTION_LIST = [
    {label: 'Cupons promocionais', value: 'promo_codes', component: <PromoCodes/>},
    {label: 'Serviços', value: 'services', component: <Services/>},
    {label: 'Categorias de serviço', value: 'service_categories', component: <ServiceCategories/>},
    {label: 'Produtos', value: 'products', component: <Products/>},
    {label: 'Categorias de produto', value: 'product_categories', component: <ProductCategories/>},
  ]

  const selectedTab = OPTION_LIST.find (o => o.value === option) || OPTION_LIST[0]

  return (
    <Container>
      <AdminNavbar/>
      <ItemTabs
        tabs={OPTION_LIST}
        selectedTab={selectedTab.value}
        onTabChange={tab => {
          setOption (tab)
          localStorage.setItem ('config_option', tab)
        }}
        tabWidth={180}
      />
      {selectedTab.component}
    </Container>
  )
}
